export const MIGRATION_KEYS = {
  LINKED_DATASET_IDS: "migration:linkedDatasetIds"
} as const;
